import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRouteWithParams = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      localStorage.getItem('user')
        ? <Component routeParams={props.match.params} {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )}
  />
);

export default PrivateRouteWithParams;
